import {
  collection,
  getDocs,
  limit,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../../../backend/firebaseConfig";

const CPD_AUTOMATION_LOGS_PATH = [
  "Compliance",
  "CPD Automation",
  "Logs",
];

const toIsoValue = (value) =>
  value?.toDate ? value.toDate().toISOString() : value || "";

export const fetchCpdAutomationLogs = async (adviserId) => {
  const normalisedAdviserId = String(adviserId || "").trim();
  if (!normalisedAdviserId) return [];

  const snapshot = await getDocs(
    query(
      collection(db, ...CPD_AUTOMATION_LOGS_PATH),
      where("adviserId", "==", normalisedAdviserId),
      limit(100),
    ),
  );

  return snapshot.docs
    .map((document) => {
      const value = document.data() || {};
      return {
        id: document.id,
        ...value,
        occurredAt: toIsoValue(value.occurredAt),
        attemptedAt: toIsoValue(value.attemptedAt),
        sentTimestamp: toIsoValue(value.sentTimestamp),
      };
    })
    .sort((left, right) =>
      String(right.occurredAt || "").localeCompare(
        String(left.occurredAt || ""),
      ),
    );
};
